<template>
  <v-toolbar color="primary" dark extended flat extension-height="82">
    <img
      src="@/assets/logo/disavowl--white.svg"
      alt
      width="150"
      class="pl-4"
      @click="routeTo('Projects')"
    />

    <v-col cols="auto">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn outlined v-on="on" text
            ><v-icon left>mdi-menu</v-icon>{{ projectName }}</v-btn
          >
        </template>
        <v-list>
          <v-list-item
            v-for="(project, index) in activeProjects"
            :key="index"
            @click="routeToProject(project.id)"
          >
            <v-list-item-title>{{ project.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
    <v-spacer></v-spacer>
    <BaseCompare v-if="isAdmin" />
    <BaseDownload v-if="isAdmin" />
    <BaseImport v-if="isAdmin" />
    <BasePermissions v-if="isAdmin" />

    <v-col cols="auto">
      <v-menu open-on-hover offset-y v-if="user">
        <template v-slot:activator="{ on }">
          <img
            v-on="on"
            class="user-image"
            :src="user.picture"
            :alt="userName"
          />
        </template>
        <v-list>
          <v-list-item @click="logout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
  </v-toolbar>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  methods: {
    logout() {
      this.$store.dispatch("user/logout");
    },
    routeToProject(id) {
      /*
      //change based on admin status
      this.$router.push({
        name: "Project",
        params: { id: id, status: "unassigned" },
      });*/
      console.log(this.$route);
      let user = this.user.user;
      if (this.isAdmin) {
        this.$router.push({
          path: `/project/a/${user}/${id}/${this.$route.params.status}`,
        });
      } else {
        this.$router.push({ path: `/project/a/${user}/${id}/mynew` });
      }
    },
    getProjectByID() {
      var project = this.projects.filter((project) => {
        return project.id === parseInt(this.$route.params.id);
      });
      console.log(this.projects);

      return project[0];
    },
    getProjectName() {
      var project = this.getProjectByID();

      return project.name;
    },
  },
  data() {
    return {
      active: null,
      drawer: true,
    };
  },
  computed: {
    userName() {
      return this.user.firstName + " " + this.user.lastName;
    },
    projectName() {
      var project = this.getProjectByID();
      console.log(project);
      return project.name;
    },
    isAdmin() {
      return this.user.admin;
    },
    ...mapState({
      user: (state) => state.user.user,
      projects: (state) => state.projects.projects,
    }),
    ...mapGetters({
      activeProjects: "projects/activeProjects",
    }),
  },
};
</script>

<style lang="scss" scoped>
.v-tabs-slider-wrapper {
  color: #ef6b00;
}
.user-image {
  border-radius: 100%;
  height: 40px;
  width: 40px;
}
</style>
